<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="w-4 h-4"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.02 0.07C9.21 -0.02 9.43 -0.02 9.62 0.07L10.28 0.4C10.5 0.51 10.64 0.74 10.64 1V10.98C10.64 11.23 10.5 11.46 10.28 11.57L9.62 11.9C9.43 12 9.21 12 9.02 11.9L7.98 11.39L6.95 11.9C6.77 12 6.54 12 6.36 11.9L5.32 11.39L4.28 11.9C4.1 12 3.88 12 3.69 11.9L2.66 11.39L1.62 11.9C1.43 12 1.21 12 1.03 11.9L0.37 11.57C0.14 11.46 0 11.23 0 10.98V1C0 0.74 0.14 0.51 0.37 0.4L1.03 0.07C1.21 -0.02 1.43 -0.02 1.62 0.07L2.66 0.59L3.69 0.07C3.88 -0.02 4.1 -0.02 4.28 0.07L5.32 0.59L6.36 0.07C6.54 -0.02 6.77 -0.02 6.95 0.07L7.98 0.59L9.02 0.07ZM2.66 7.81C2.39 7.81 2.16 8.04 2.16 8.31C2.16 8.59 2.39 8.81 2.66 8.81H5.32C5.6 8.81 5.82 8.59 5.82 8.31C5.82 8.04 5.6 7.81 5.32 7.81H2.66ZM7.32 7.78C7.04 7.78 6.82 8 6.82 8.28C6.82 8.55 7.04 8.78 7.32 8.78H7.98C8.26 8.78 8.48 8.55 8.48 8.28C8.48 8 8.26 7.78 7.98 7.78H7.32ZM2.66 5.49C2.38 5.49 2.16 5.71 2.16 5.99C2.16 6.26 2.38 6.49 2.66 6.49H5.32C5.6 6.49 5.82 6.26 5.82 5.99C5.82 5.71 5.6 5.49 5.32 5.49H2.66ZM7.32 5.49C7.04 5.49 6.82 5.71 6.82 5.99C6.82 6.26 7.04 6.49 7.32 6.49H7.98C8.26 6.49 8.48 6.26 8.48 5.99C8.48 5.71 8.26 5.49 7.98 5.49H7.32ZM2.66 3.16C2.39 3.16 2.16 3.38 2.16 3.66C2.16 3.93 2.39 4.16 2.66 4.16H7.98C8.26 4.16 8.48 3.93 8.48 3.66C8.48 3.38 8.26 3.16 7.98 3.16H2.66Z"
      :fill="active ? 'url(#invoice_blue)' : 'url(#invoice_gray)'"
    />
    <defs>
      <linearGradient id="invoice_blue" x1="0.48" y1="10.48" x2="11.24" y2="4.75" gradientUnits="userSpaceOnUse">
        <stop stop-color="#C7CBFF" />
        <stop offset="1" stop-color="#0012FA" />
      </linearGradient>
      <linearGradient id="invoice_gray" x1="0.48" y1="10.48" x2="11.24" y2="4.75" gradientUnits="userSpaceOnUse">
        <stop stop-color="#D3D5E4" />
        <stop offset="1" stop-color="#585B79" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
defineProps<{
  active?: boolean
}>()
</script>
